<template>
    <el-dialog :visible="visible" class="ah-detail-dialog variable-statement-detail-editor-sample-detail-dialog" @open="onOpen" @close="onClose(false)">
        <template slot="title">
            <div class="title">
                <span>{{ isEditMode ? "編輯" : "新增" }}範本</span>
            </div>
        </template>

        <div class="detail-row" style="padding-top: 30px">
            <div style="margin-bottom: 20px">
                <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="160px">
                    <div style="margin: 0 auto 20px auto">
                        <el-form-item prop="name" label="名稱">
                            <el-input v-model.trim="form.name" :maxlength="200" style="width: 220px" :show-word-limit="true" />
                        </el-form-item>
                        <el-form-item v-if="!isEditMode" prop="copyFrom" label="複製範本">
                            <el-select v-model="form.copyFrom" size="small" filterable style="width: 320px">
                                <el-option v-for="template in templateList" :key="template.id" :value="template.id" :label="template.label" />
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="main-action">
                <el-button v-if="isEditMode" @click="onDelete"> 刪除 </el-button>
                <div v-else></div>
                <div>
                    <el-button @click="onClose(false)">取消</el-button>
                    <el-button type="primary" class="primary-action" @click="onSubmit">
                        <span v-if="isEditMode">儲存</span>
                        <span v-else>新增</span>
                    </el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import FirebaseSDK from '@/utils/firebaseSDK';

const firebase = new FirebaseSDK();

export default {
    props: {
        visible: Boolean,
        sampleList: {
            type: Object,
            default: () => {},
        },
        templateList: {
            type: Array,
            default: () => [],
        },
        id: null,
        isEditMode: Boolean,
    },
    data() {
        return {
            form: {
                name: '',
                copyFrom: null,
            },
            rules: {
                name: [{ required: true, message: '請輸入名稱' }],
                copyFrom: [{ required: true, message: '請選擇範本' }],
            },
        };
    },
    computed: {
        isNameDuplicated() {
            const FOUND = _.findKey(this.sampleList, ['name', this.form.name]);

            if (FOUND) {
                this.$message({
                    showClose: true,
                    message: '範本名稱重複',
                    type: 'error',
                });
                return true;
            }
            return false;
        },
    },
    methods: {
        onOpen() {
            if (this.isEditMode) {
                const FOUND = this.templateList.find((o) => o.id === this.id);
                this.form.name = FOUND.label;
            } else {
                this.form = { name: '', copyFrom: null };
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                });
            }
        },
        onClose(refresh) {
            this.$emit('close', refresh);
        },
        async onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) return false;
                this.onMutate();
                return true;
            });
        },
        async onMutate() {
            if (this.isNameDuplicated) return;
            try {
                if (this.isEditMode) {
                    await this.onUpdate();
                    this.onClose(true);
                } else {
                    const resp = await this.onAdd();
                    this.onClose(resp.id);
                }
            } catch (e) {
                console.log(e);
            }
        },

        async onUpdate() {
            const DATA = this.sampleList[this.id];
            await firebase.updateSample(this.id, { ...DATA, name: this.form.name });
        },

        onAdd() {
            const DATA = this.sampleList[this.form.copyFrom];
            return firebase.addSample(this.form.name, DATA);
        },

        async onDelete() {
            try {
                await this.$confirm('確定要刪除？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.$emit('delete', this.id);
                this.onClose();
            } catch (e) {
                console.log(e);
            }
        },
    },
};
</script>

<style lang="scss">
.ah-detail-dialog.variable-statement-detail-editor-sample-detail-dialog {
    .el-dialog {
        max-width: 560px;
    }
    .title {
        text-align: center;
    }
    .main-action {
        display: flex;
        justify-content: space-between;
    }
}
</style>
